var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'relative py-12': _vm.loading }},[(_vm.loading)?_c('LoadingSpinner'):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }